import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { dataModel } from './ReviewDataModel';
import { RatingsAndReviewsDefaultProps, RatingsAndReviewsPropTypes } from './RatingsAndReviewsPropTypes';
import { RatingsAndReviewsPlaceholder } from './RatingsAndReviewsPlaceholder';

const placeholder = (
  <RatingsAndReviewsPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./RatingsAndReviewsMobile')).RatingsAndReviewsMobile;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews-mobile" */
      './RatingsAndReviewsMobile');
  },
  placeholder,
  name: 'RatingsAndReviewsMobile'
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'product-section-rr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const RatingsAndReviewsMobileImporter = withErrorBoundary(DynamicComponent);

RatingsAndReviewsMobileImporter.displayName = 'RatingsAndReviewsMobileImporter';
RatingsAndReviewsMobileImporter.propTypes = RatingsAndReviewsPropTypes;
RatingsAndReviewsMobileImporter.defaultProps = RatingsAndReviewsDefaultProps;
RatingsAndReviewsMobileImporter.dataModel = dataModel;
